// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionReason-cls1_ytA","cls2":"SuggestionReason-cls2_12n SuggestionReason-cls1_ytA"};